import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Pagination } from './pagination.model';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  currentPage: number = 1;
  totalItems: number = 0;

  @Input() pageConfig!: any;
  @Output() pageChange: EventEmitter<Pagination> =
    new EventEmitter<Pagination>();

  constructor() {}

  ngOnInit(): void {}

  setPage(page: any) {
    if (
      page > 0 &&
      page <= this.pageConfig?.totalPage &&
      page !== this.pageConfig.currentPage
    ) {
      this.pageConfig.currentPage = page;
      this.refreshPage();
    }
  }

  changedPage(page: any) {
    let valuePage = page.target.value;

    if (valuePage - 1 > 0 && valuePage - 1 < this.pageConfig?.totalPage) {
      this.pageConfig.currentPage = valuePage;
      this.refreshPage();
    } else {
      this.pageConfig.currentPage = 1;
      this.refreshPage();
    }
  }

  changedNumOfItem(numOfItem: any) {
    this.pageConfig.limit = numOfItem;
    this.pageConfig.currentPage = 1;
    this.refreshPage();
  }

  refreshPage() {
    this.pageChange.emit(this.pageConfig);
  }
}
